import React, { Component } from "react";

import { DKLabel, DKButton } from "deskera-ui-library";
import LandingPageManager from "./LandingPageManager";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import DirectLinkSection from "../common/DirectLinkSection";
import LandingPageHeader from "./LandingPageHeader";

class LandingPageDomain extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
    if (
      !LandingPageManager.isPageDataAvailable() &&
      this.props.match.params.id
    ) {
      LandingPageManager.fetchPageDataById(this.props.match.params.id, () => {
        this.setState({});
      });
    }
  }
  render() {
    return (
      <div className="column parent-width  ">
        <LandingPageHeader title={"Publish Email Template"} stepperIndex={2} />
        <div
          className="column p-xl bg-white border-radius-s parent-width border-box mt-xl align-self-center shadow-s align-items-center"
          style={{ maxWidth: 800, marginBottom: 100 }}
        >
          <div className="" style={{ fontSize: 50 }}>
            🥳
          </div>
          <DKLabel
            text="Hurray! email template Published"
            className="fw-m mt-m fs-xl"
          />
          <DKLabel
            text="Your email template has been created successfully"
            className="mt-s"
          />

          {/* /////////// */}

          <DirectLinkSection
            className="mt-xl"
            url={LandingPageManager.getDirectLink()}
          />

          {/* /////////// */}

          {/* /////////// */}

          <DKLabel
            text="You can visit to form homepage / list page to see how it is performing."
            className="mt-xxl "
          />

          <DKButton
            title="Email template list"
            className="bg-app text-white mt-l"
            onClick={() => {
              RouteManager.navigateToPage(PAGE_ROUTES.EMAIL_TEMPLATE.LIST);
            }}
          />
        </div>
      </div>
    );
  }
}

export default LandingPageDomain;
